import { useState } from 'react';
import { getCookie } from '../data/Cookies';
import mockApi from '../api/mockApi';
import { Period } from '../components/widgets/HistoryBarGraph'

export default function useChargingHistory() {
    let id = getCookie("id");

    const [history, setHistory] = useState();

    const getHistory = async () => {
        const response = await mockApi.get('/getHistory/' + id);
        const historyTemp = createHistory(response.data);
        setHistory(historyTemp);
    };

    function createHistory(data) {
        var historyWeek = getEmptyList(7);
        var historyMonth = getEmptyList(31);
        var historyYear = getEmptyList(12);

        const now = new Date(Date.now());
        var unixTimePeriodWeek = Number(now) - 604800000;
        var unixTimePeriodMonth = Number(now) - 2629743000;
        var unixTimePeriodYear = Number(now) - 31556926000;

        const keys = Object.keys(data);

        keys.forEach(key => {
            const entryDateTime = new Date(data[key]["arrival"]);
            const duration = new Date(new Date(data[key]["departure"]) - entryDateTime);
            const historyEntry = {
                    energy: Math.round(data[key]["session_energy"] / 1000),
                    emissions: Number(data[key]["session_points_co2"]),
                    date: data[key]["arrival"],
                    duration: duration.getHours(),
                    solar: Number(data[key]["session_points_solar_consumption"])
                };

            if (entryDateTime.getTime() > unixTimePeriodWeek) {
                var day = now.getDate() - entryDateTime.getDate() - 1;
                historyWeek[day] = (historyEntry);
            }

            if (entryDateTime.getTime() > unixTimePeriodMonth) {
                var day = entryDateTime.getDate();
                historyMonth[day] = (historyEntry);
            }

            if (entryDateTime.getTime() > unixTimePeriodYear) {
                var month = entryDateTime.getMonth();
                historyYear[month].push(historyEntry);
            }
        })

        historyYear = aggregateOnMonth(historyYear);
        historyYear = adjustDisplayFromToday(historyYear, Period.year, false);
        historyMonth = adjustDisplayFromToday(historyMonth, Period.month, false);

        const historyTemp = {week: historyWeek, month: historyMonth, year: historyYear};
        return historyTemp;
    }

    function aggregateOnMonth(historyYear) {
        var i = 0;
        var newHistoryYear = getEmptyList(12);
        historyYear.forEach((entireMonth) => {
            var totalEnergy = 0;
            var totalEmissions = 0;
            var totalDuration = 0;
            var totalSolar = 0;
            
            if (entireMonth.length != 0) {

                entireMonth.forEach((entry) => {
                    totalEnergy += entry.energy;
                    totalEmissions += entry.emissions;
                    totalDuration += entry.duration;
                    totalSolar += entry.solar;
                })

                const date = new Date(entireMonth[0].date);
                const monthName = date.toLocaleString('en-US', { month: 'short' });

                newHistoryYear[i] = {
                    energy: totalEnergy,
                    emissions: totalEmissions,
                    date: monthName,
                    duration: totalDuration,
                    solar: totalSolar
                };

                i ++;
                totalEnergy = totalEmissions = totalDuration = totalSolar = 0;
            } else {
                newHistoryYear[i] = [];
            }
        })

        return newHistoryYear;
    }

    function adjustDisplayFromToday(list, period, label) {
        const now = new Date(Date.now());
        var cutoff = 0; 
        var length; 

        switch (period) {
            case Period.week:
                cutoff = now.getDay();
                length = 7;
                if (label) cutoff -= 1;
                break;
            case Period.month:
                cutoff = now.getDate();
                length = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
                break;
            case Period.year:
                cutoff = now.getMonth();
                length = 12;
                if (label) {
                    cutoff += 1;
                } else {
                    cutoff -= 1;
                }
                break;
        }

        list = (list.slice(cutoff, length)).concat(list.slice(0, cutoff));
        list.reverse();
        return list;
    }

    function getEmptyList(n) {
        var emptyList = [];
        for (var i = 0; i != n; i ++) {
            emptyList.push([]);
        }
        return emptyList;
    }

    return {history: history, getHistory: getHistory};
};

